enum ElectronicClientRecordClientAlertType {
  Infection = 'Infection',
  Aggression = 'Aggression',
  Warning = 'Warning',
  Unknown = 'Unknown',
}

export default ElectronicClientRecordClientAlertType;
